/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import {
  Form, SaveButton, SimpleForm, Toolbar, useNotify,
} from 'react-admin';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import PostionArrayInput from '../../../components/system/settings/positionArrayInput';
import { actions } from '../../../redux/system/settings';
import EditToolBar from '../../../components/commons/editToolBar';
import canAccess from '../../../utils/canAccess';
import FUNC from '../../../utils/functions';

export default React.memo(() => {
  const { permissions } = useSelector((state: any) => state.app.appState);
  const canShow = canAccess(permissions, FUNC.SETTINGS);
  const canEdit = canAccess(permissions, FUNC.TYPE_OF_STUDENT_SETTING);
  const [typeOfStudent, setTypeOfStudent] = useState(null);
  const { data } = useSelector((state: any) => state.settings);
  const dispatch = useDispatch();
  useEffect(() => {
    setTypeOfStudent(data?.list?.find((item: any) => item.id === 'typeOfStudent')?.value);
  }, [data]);
  const studentKeys = ['name'];
  const hiddenKeys = ['id', 'order'];
  const notify = useNotify();
  const onSuccess = () => {
    notify('dut.msg.save_data_success', {
      type: 'info',
    });
  };
  const transform = (val: any) => {
    const list: any[] = [];
    Object.keys(val).forEach((key) => {
      const property = val[key];
      property.forEach((element: any, index: any) => {
        element.order = index + 1;
        if (element.id === '') {
          element.id = Math.max(...property.map((item: any) => item.id)) + 1;
        }
      });
      const position: { id: string, value: any } = { id: key, value: property };
      list.push(position);
    });
    dispatch(actions.putInt({ list, onSuccess }));
  };
  if (!canShow) return null;
  return (
    <SimpleForm toolbar={<EditToolBar isSave={canEdit} />} onSubmit={transform}>
      <Grid container spacing={2} rowSpacing={0.5}>
        <Grid item xs={12} md={10}>
          <Grid item xs={12} md={10}>
            <PostionArrayInput
              keys={studentKeys}
              canEdit={canEdit}
              hiddenKeys={hiddenKeys}
              datas={typeOfStudent}
              source="typeOfStudent"
            />
          </Grid>
        </Grid>
      </Grid>
    </SimpleForm>
  );
});
